exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3oH7e2MBoSGgj9nKqSBQf5 {\r\n    overflow: hidden;\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n\r\n._2-BQr8LObor-byQrzqjsID {\r\n    align-items: center;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    height: 100%;\r\n    float: left;\r\n    justify-content: center;\r\n    overflow: hidden;\r\n    position: relative;\r\n}\r\n\r\n._2ZHMZfqgzQ-XLxI8KYXTug {\r\n    transform-origin: right center;\r\n}\r\n\r\n.Oeq4ALZKg_fdS7nbBJyqt {\r\n    box-sizing: content-box;\r\n    transform-origin: center center;\r\n}\r\n\r\n._1jj1jPnSxnlfeEFZ3-r2Yc {\r\n    transform-origin: left center;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "_3oH7e2MBoSGgj9nKqSBQf5",
	"gif": "_2-BQr8LObor-byQrzqjsID",
	"next": "_2ZHMZfqgzQ-XLxI8KYXTug _2-BQr8LObor-byQrzqjsID",
	"current": "Oeq4ALZKg_fdS7nbBJyqt _2-BQr8LObor-byQrzqjsID",
	"previous": "_1jj1jPnSxnlfeEFZ3-r2Yc _2-BQr8LObor-byQrzqjsID"
};